export default __webpack_public_path__ + "static/media/img_post6_7.e306070d.png";